import { render } from "./ProductUnitDetails.vue?vue&type=template&id=1bb32545"
import script from "./ProductUnitDetails.vue?vue&type=script&lang=js"
export * from "./ProductUnitDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__